// extracted by mini-css-extract-plugin
module.exports = {"page":"jD-z","cartModal":"kD-z","checkout":"lD-z","placeholder":"mD-z","account":"nD-z"};